import { MemberSeatsSelectTable } from './MemberSeatsSelectTable';
export default MemberSeatsSelectTable;
